var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "Statistics", attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        [
          !_vm.isAbnormalStatistics
            ? [
                _c(
                  "v-flex",
                  { attrs: { md2: "" } },
                  [
                    _c("v-select", {
                      attrs: {
                        label: _vm.$t("dateType"),
                        small: "",
                        "item-text": "label",
                        "item-value": "value",
                        items: _vm.dateTypes,
                        "return-object": false
                      },
                      model: {
                        value: _vm.mode,
                        callback: function($$v) {
                          _vm.mode = $$v
                        },
                        expression: "mode"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.mode === "month"
                  ? _c(
                      "v-flex",
                      { attrs: { md2: "" } },
                      [
                        _c("DatePicker", {
                          key: "month",
                          attrs: { mode: "month" },
                          model: {
                            value: _vm.month,
                            callback: function($$v) {
                              _vm.month = $$v
                            },
                            expression: "month"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "date"
            ? _c(
                "v-flex",
                { attrs: { md2: "" } },
                [
                  _c("DatePicker", {
                    key: "date",
                    attrs: {
                      mode: "date",
                      range: true,
                      max: _vm.dateMax,
                      min: _vm.dateMin
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c(
                                "v-btn",
                                {
                                  attrs: { flat: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setDate(7)
                                    }
                                  }
                                },
                                [_vm._v("\n            近一周\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { flat: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setDate(30)
                                    }
                                  }
                                },
                                [_vm._v("\n            近30天\n          ")]
                              ),
                              _vm._v(" "),
                              _vm.isAbnormalStatistics
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: { flat: "", color: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setDate(-1)
                                        }
                                      }
                                    },
                                    [_vm._v("\n            全部\n          ")]
                                  )
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      31069017
                    ),
                    model: {
                      value: _vm.date,
                      callback: function($$v) {
                        _vm.date = $$v
                      },
                      expression: "date"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-flex", { attrs: { md1: "" } }),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md1: "" } },
            [
              _c("LoaderButton", {
                attrs: {
                  loading: _vm.loading,
                  buttonText: _vm.$t("search"),
                  promiseAwait: _vm.getData
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            { attrs: { md12: "" } },
            [
              _c("v-chart", {
                attrs: {
                  options: _vm.leftChartOption,
                  "init-options": _vm.initOptions,
                  theme: "ovilia-green",
                  autoresize: ""
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md12: "" } },
            [
              _c("v-chart", {
                attrs: {
                  options: _vm.rightChartOption,
                  "init-options": _vm.initOptions,
                  theme: "ovilia-green",
                  autoresize: ""
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isAbnormalStatistics
        ? _c(
            "v-layout",
            { attrs: { "justify-end": "", "align-center": "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.exportFile.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("export")) + "\n    ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            { attrs: { md22: "" } },
            [
              _c("v-data-table", {
                staticClass: "table",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.targetData,
                  pagination: _vm.pagination
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _vm.isAbnormalStatistics
                          ? _c(
                              "tr",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.showDetails(props.item)
                                  }
                                }
                              },
                              [
                                _c("td", [_vm._v(_vm._s(props.item.channel))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(props.item.invCount))]),
                                _vm._v(" "),
                                _vm._l(_vm.headers.slice(2), function(row, i) {
                                  return _c("td", { key: i }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          row.format
                                            ? row.format(props.item, row)
                                            : props.item[row.value] || 0
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                })
                              ],
                              2
                            )
                          : _c(
                              "tr",
                              [
                                _c("td", [
                                  _vm._v(_vm._s(props.item.clientName))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticStyle: { width: "300px" } }, [
                                  _vm._v(_vm._s(props.item.department))
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(props.item.manager))]),
                                _vm._v(" "),
                                _vm._l(_vm.headers.slice(3), function(row, i) {
                                  return _c("td", { key: i }, [
                                    _vm._v(
                                      "\n              $" +
                                        _vm._s(
                                          _vm.dataTypes
                                            .map(function(item) {
                                              return _vm.formatTableCell(
                                                props.item,
                                                row,
                                                item
                                              )
                                            })
                                            .join(" / ")
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                })
                              ],
                              2
                            )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isAbnormalStatistics
        ? _c("TablePopup", {
            staticClass: "table",
            attrs: {
              title: _vm.detailPopup.channel + " " + _vm.$t("detail"),
              hideRgtBtn: "",
              large: ""
            },
            on: {
              popupClose: function($event) {
                return _vm.$emit("input", (_vm.detailPopup.show = false))
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-container",
                        [
                          _c("v-data-table", {
                            attrs: {
                              headers: _vm.detailHeaders,
                              items: _vm.detailPopup.data,
                              pagination: _vm.detailPagination
                            },
                            on: {
                              "update:pagination": function($event) {
                                _vm.detailPagination = $event
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "tr",
                                        [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(props.item.clientName)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(props.item.department)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(props.item.manager))
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.detailHeaders.slice(3),
                                            function(row, i) {
                                              return _c("td", { key: i }, [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      row.format
                                                        ? row.format(
                                                            props.item,
                                                            row
                                                          )
                                                        : props.item[
                                                            row.value
                                                          ] || 0
                                                    ) +
                                                    "\n              "
                                                )
                                              ])
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3406497343
                            )
                          })
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3149385643
            ),
            model: {
              value: _vm.detailPopup.show,
              callback: function($$v) {
                _vm.$set(_vm.detailPopup, "show", $$v)
              },
              expression: "detailPopup.show"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c46fc5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c46fc5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Statistics.vue
// module id = null
// module chunks = 